import React from "react";

import aboutusImg from "./images/aboutusimg.jpeg"

function AboutUs() {
  return (
    <>
      <section className="about-us">
        <div className="about-us-inner">
          {/* LEFT: Text */}
          <div className="about-us-text">
            <h2 className="about-us-title">About Us</h2>
            <p className="about-us-desc">
              We always put our customers first, ensuring your needs are met
              from the very beginning of our process till you have your
              desired goods in hand.
            </p>
            <a href="/about" className="about-us-btn">
              Read More
              <span className="about-us-arrow">→</span>
            </a>
          </div>

          {/* RIGHT: Image */}
          <div className="about-us-image">
            <img
              src={`${aboutusImg}`}
              alt="Prosep Services products"
            />
          </div>
        </div>
      </section>

      <style>{`
        .about-us {
          width: 100%;
          padding: 80px 40px;
          background: linear-gradient(
            135deg,
            #001a3d 0%,
            #002a5c 45%,
            #0047a3 100%
          );
          font-family: Arial, sans-serif;
          box-sizing: border-box;
        }

        .about-us-inner {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1.15fr;
          align-items: center;
          gap: 60px;
        }

        /* ============ LEFT: TEXT ============ */
        .about-us-text {
          color: #fff;
        }

        .about-us-title {
          font-size: 30px;
          font-weight: 900;
          letter-spacing: 0.5px;
          margin: 0 0 20px;
          color: #ffffff;
          line-height: 1.15;
        }

        .about-us-desc {
          font-size: 17px;
          line-height: 1.7;
          color: #dbe5f0;
          margin: 0 0 32px;
          max-width: 560px;
        }

        .about-us-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 14px 28px;
          background: #ffffff;
          color: #0a1a35;
          text-decoration: none;
          font-size: 15px;
          font-weight: 700;
          border-radius: 999px;
          transition: all 0.2s ease;
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
        }
        .about-us-btn:hover {
          background: #f3f4f6;
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.22);
        }
        .about-us-arrow {
          font-size: 17px;
          transition: transform 0.2s ease;
          display: inline-block;
        }
        .about-us-btn:hover .about-us-arrow {
          transform: translateX(4px);
        }

        /* ============ RIGHT: IMAGE ============ */
        .about-us-image {
          width: 100%;
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.35);
          background: #0b0e14;
        }

        .about-us-image img {
          display: block;
          width: 100%;
          height: auto;
          object-fit: cover;
        }

        /* ============ RESPONSIVE ============ */
        @media (max-width: 1000px) {
          .about-us-inner {
            grid-template-columns: 1fr;
            gap: 40px;
          }
          .about-us-title {
            font-size: 34px;
          }
          .about-us-desc {
            font-size: 16px;
            max-width: 100%;
          }
        }

        @media (max-width: 600px) {
          .about-us {
            padding: 50px 20px;
          }
          .about-us-title {
            font-size: 28px;
          }
          .about-us-desc {
            font-size: 15px;
            margin-bottom: 24px;
          }
          .about-us-btn {
            padding: 12px 22px;
            font-size: 14px;
          }
          .about-us-image {
            border-radius: 10px;
          }
        }
      `}</style>
    </>
  );
}

export default AboutUs;